import { SelectBoxMulti } from '@core/components/SelectBoxMulti/SelectBoxMulti';
import { photosState, setSelectedScanners } from '@photos/components/PhotosInViewport/state';
import { useSnapshot } from 'valtio';

export const getScannersBySerials = (serials: string[]) => {
  return photosState.possibleScanners.filter((scanner) =>
    serials.some((s) => s === scanner.serial),
  );
};

export const PhotosScanners = () => {
  const { showPhotos, selectedScanners, possibleScanners } = useSnapshot(photosState);

  return (
    <SelectBoxMulti
      label="Scanners"
      availableItems={possibleScanners.map((s) => s.serial)}
      items={selectedScanners.map((s) => s.serial)}
      setItems={(item) => {
        const newSelectedScanners = getScannersBySerials(item);
        setSelectedScanners(newSelectedScanners);
      }}
      disabled={!showPhotos}
    />
  );
};
